export const E164_PHONE_NUMBER_REGEXP = /^(\+1)([1-9]\d{2})(\d{3})(\d{4})$/;
export const US_PHONE_NUMBER_REGEXP = /^(\+1\s)?\(([1-9]\d{2})\)\s(\d{3})-(\d{4})$/;
export const CARDHOLDER_NAME_REGEXP = /^[\s]*[a-zA-Z]+(([',. -][a-zA-Z\s])?[a-zA-Z\s]*)*[\s]*$/;
//# sourceMappingURL=regex-constants.js.map